"use client";
import React from "react";
import { Provider } from "react-redux";
import { store } from "@/redux/store";
import { ToastContainer } from "react-toastify";

export default function MainLayout({ children }) {
  return (
    <Provider store={store}>
      <ToastContainer
        style={{ fontSize: "16px", zIndex: "99999" }}
        autoClose={3000}
        position="top-center"
      />
      {children}
    </Provider>
  );
}
